import styled from 'styled-components';

export const ToolbarContainer = styled.div`
  display: flex;
  justify-content: space-between;

    button {
      color: ${({ theme }) => theme.white};
    }
`;
